import useActivePage from "./ActivePage.hook";

export default useActivePage;
